/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * NoorWriter API
 * API for NoorWriter Chrome extension - AI writing assistant
 *
 * The version of the OpenAPI document: v1
 * Contact: contact@noorways.fr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios from 'axios'
import type { AxiosPromise, AxiosInstance } from 'axios'
import type { Configuration } from '../configuration'
import type { RequestConfig } from '../base'
// Some imports not used depending on template conditions
// @ts-ignore
import * as Common from '../common'
const {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} = Common
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from '../base'
import type { RequestArgs } from '../base'
// @ts-ignore
import type { CancelSubscriptionResponse } from '../models'
// @ts-ignore
import type { CheckoutSessionResponse } from '../models'
// @ts-ignore
import type { CreateCheckoutSessionRequest } from '../models'
// @ts-ignore
import type { ProblemDetails } from '../models'
// @ts-ignore
import type { SubscriptionRequest } from '../models'
// @ts-ignore
import type { SubscriptionResponse } from '../models'
/**
 * SubscriptionApi - axios parameter creator
 * @export
 */
export const SubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Sample request:                  GET /api/Subscription/can-use/improve
     * @summary Checks if a user can use a specific operation
     * @param {string} operation The operation to check (e.g., \&quot;improve\&quot;, \&quot;rewrite\&quot;, \&quot;generate\&quot;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    canUseOperation: async (
      operation: string,
      options: RequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'operation' is not null or undefined
      assertParamExists('canUseOperation', 'operation', operation)
      const localVarPath = `/api/Subscription/can-use/{operation}`.replace(
        `{${'operation'}}`,
        encodeURIComponent(String(operation))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Cancels the user\'s premium subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSubscription: async (options: RequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/Subscription/cancel`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Creates a Stripe Checkout session and returns the checkout URL
     * @param {CreateCheckoutSessionRequest} [createCheckoutSessionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCheckoutSession: async (
      createCheckoutSessionRequest?: CreateCheckoutSessionRequest,
      options: RequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Subscription/create-checkout-session`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createCheckoutSessionRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Sample request:                  GET /api/Subscription     X-User-Id: user-123
     * @summary Gets subscription information for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscription: async (options: RequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/Subscription`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns current subscription status (alias to GET /api/subscription)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    status: async (options: RequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/Subscription/status`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Sample request:                  POST /api/Subscription/update     {        \"userId\": \"user-123\",        \"plan\": \"premium\"     }              Plans: - free: Free plan with limited features and usage - premium: Premium plan with all features and unlimited usage
     * @summary Updates a user\'s subscription plan
     * @param {SubscriptionRequest} [subscriptionRequest] The subscription request containing user ID and plan information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubscription: async (
      subscriptionRequest?: SubscriptionRequest,
      options: RequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Subscription/update`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        subscriptionRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Webhook receiver for Stripe events (placeholder)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhook: async (options: RequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/Subscription/webhook`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * SubscriptionApi - functional programming interface
 * @export
 */
export const SubscriptionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SubscriptionApiAxiosParamCreator(configuration)
  return {
    /**
     * Sample request:                  GET /api/Subscription/can-use/improve
     * @summary Checks if a user can use a specific operation
     * @param {string} operation The operation to check (e.g., \&quot;improve\&quot;, \&quot;rewrite\&quot;, \&quot;generate\&quot;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async canUseOperation(
      operation: string,
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.canUseOperation(operation, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Cancels the user\'s premium subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelSubscription(
      options?: RequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelSubscriptionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSubscription(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Creates a Stripe Checkout session and returns the checkout URL
     * @param {CreateCheckoutSessionRequest} [createCheckoutSessionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCheckoutSession(
      createCheckoutSessionRequest?: CreateCheckoutSessionRequest,
      options?: RequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutSessionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createCheckoutSession(
        createCheckoutSessionRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Sample request:                  GET /api/Subscription     X-User-Id: user-123
     * @summary Gets subscription information for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSubscription(
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscription(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Returns current subscription status (alias to GET /api/subscription)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async status(
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.status(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     * Sample request:                  POST /api/Subscription/update     {        \"userId\": \"user-123\",        \"plan\": \"premium\"     }              Plans: - free: Free plan with limited features and usage - premium: Premium plan with all features and unlimited usage
     * @summary Updates a user\'s subscription plan
     * @param {SubscriptionRequest} [subscriptionRequest] The subscription request containing user ID and plan information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSubscription(
      subscriptionRequest?: SubscriptionRequest,
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscription(
        subscriptionRequest,
        options
      )
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
    /**
     *
     * @summary Webhook receiver for Stripe events (placeholder)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async webhook(
      options?: RequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.webhook(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
  }
}

/**
 * SubscriptionApi - factory interface
 * @export
 */
export const SubscriptionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SubscriptionApiFp(configuration)
  return {
    /**
     * Sample request:                  GET /api/Subscription/can-use/improve
     * @summary Checks if a user can use a specific operation
     * @param {string} operation The operation to check (e.g., \&quot;improve\&quot;, \&quot;rewrite\&quot;, \&quot;generate\&quot;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    canUseOperation(operation: string, options?: any): AxiosPromise<any> {
      return localVarFp
        .canUseOperation(operation, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Cancels the user\'s premium subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSubscription(options?: any): AxiosPromise<CancelSubscriptionResponse> {
      return localVarFp.cancelSubscription(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Creates a Stripe Checkout session and returns the checkout URL
     * @param {CreateCheckoutSessionRequest} [createCheckoutSessionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCheckoutSession(
      createCheckoutSessionRequest?: CreateCheckoutSessionRequest,
      options?: any
    ): AxiosPromise<CheckoutSessionResponse> {
      return localVarFp
        .createCheckoutSession(createCheckoutSessionRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Sample request:                  GET /api/Subscription     X-User-Id: user-123
     * @summary Gets subscription information for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscription(options?: any): AxiosPromise<SubscriptionResponse> {
      return localVarFp.getSubscription(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns current subscription status (alias to GET /api/subscription)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    status(options?: any): AxiosPromise<SubscriptionResponse> {
      return localVarFp.status(options).then((request) => request(axios, basePath))
    },
    /**
     * Sample request:                  POST /api/Subscription/update     {        \"userId\": \"user-123\",        \"plan\": \"premium\"     }              Plans: - free: Free plan with limited features and usage - premium: Premium plan with all features and unlimited usage
     * @summary Updates a user\'s subscription plan
     * @param {SubscriptionRequest} [subscriptionRequest] The subscription request containing user ID and plan information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubscription(
      subscriptionRequest?: SubscriptionRequest,
      options?: any
    ): AxiosPromise<SubscriptionResponse> {
      return localVarFp
        .updateSubscription(subscriptionRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Webhook receiver for Stripe events (placeholder)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhook(options?: any): AxiosPromise<void> {
      return localVarFp.webhook(options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */
export class SubscriptionApi extends BaseAPI {
  /**
   * Sample request:                  GET /api/Subscription/can-use/improve
   * @summary Checks if a user can use a specific operation
   * @param {string} operation The operation to check (e.g., \&quot;improve\&quot;, \&quot;rewrite\&quot;, \&quot;generate\&quot;)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */
  public canUseOperation(operation: string, options?: RequestConfig) {
    return SubscriptionApiFp(this.configuration)
      .canUseOperation(operation, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Cancels the user\'s premium subscription
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */
  public cancelSubscription(options?: RequestConfig) {
    return SubscriptionApiFp(this.configuration)
      .cancelSubscription(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Creates a Stripe Checkout session and returns the checkout URL
   * @param {CreateCheckoutSessionRequest} [createCheckoutSessionRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */
  public createCheckoutSession(
    createCheckoutSessionRequest?: CreateCheckoutSessionRequest,
    options?: RequestConfig
  ) {
    return SubscriptionApiFp(this.configuration)
      .createCheckoutSession(createCheckoutSessionRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Sample request:                  GET /api/Subscription     X-User-Id: user-123
   * @summary Gets subscription information for a user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */
  public getSubscription(options?: RequestConfig) {
    return SubscriptionApiFp(this.configuration)
      .getSubscription(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns current subscription status (alias to GET /api/subscription)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */
  public status(options?: RequestConfig) {
    return SubscriptionApiFp(this.configuration)
      .status(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Sample request:                  POST /api/Subscription/update     {        \"userId\": \"user-123\",        \"plan\": \"premium\"     }              Plans: - free: Free plan with limited features and usage - premium: Premium plan with all features and unlimited usage
   * @summary Updates a user\'s subscription plan
   * @param {SubscriptionRequest} [subscriptionRequest] The subscription request containing user ID and plan information
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */
  public updateSubscription(subscriptionRequest?: SubscriptionRequest, options?: RequestConfig) {
    return SubscriptionApiFp(this.configuration)
      .updateSubscription(subscriptionRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Webhook receiver for Stripe events (placeholder)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */
  public webhook(options?: RequestConfig) {
    return SubscriptionApiFp(this.configuration)
      .webhook(options)
      .then((request) => request(this.axios, this.basePath))
  }
}
